export const schedule = {
  "Let's schedule?": '¿Agendamos?',
  Schedule: 'Agendamiento',
  'Try again': 'Intentar otra vez',
};
